export default "__VITE_ASSET__DPZP6qgN__"